import CustomDropdown from "@UI/CustomDropdown"
import { Button } from "antd"
import { ReactComponent as ClipboardIcon } from './assets/clipboard.svg'
import './styles.css'
import UsersModal from "./components/UsersModal/UsersModal"
import { useDownloadTemplateCollection } from "./hooks/useDownloadTemplateCollection"
import { useRef } from "react"

const DownloadTemplateCollection = () => {

  const { isLoading, isOpenModal, debtors, handleOpenCloseModal, handleUploadTemplate, handleDownloadAllDebtorsTemplate } = useDownloadTemplateCollection()
  const inputRef = useRef(null)


  return (
    <div className="download-template-collection">
      <div>
        <ClipboardIcon />
      </div>
      <div>
        <h1>Descargar plantilla de cobros</h1>
        <p>Antes de agregar cobros a los usuarios, primero debes descargar la plantilla de Excel.En esta plantilla ya estarán incluidos los usuarios que deseas facturar. Puedes elegir entre:
        </p>
        <ol>
          <li>Todos los usuarios: Se descargará un archivo con todos los usuarios registrados.
          </li>
          <li>Selección manual: Podrás elegir qué usuarios incluir antes de generar la plantilla.</li>
        </ol>
        <p>
          Después de completar la plantilla con la información de los cobros, podrás subirla nuevamente al sistema.</p>
        <div className="download-template-collection-buttons">
          <input
            type="file"
            name="file"
            id="file"
            multiple={false}
            style={{ display: 'none' }}
            ref={inputRef}
            onChange={(event) => handleUploadTemplate({ event })}
          />
          <Button
            className="btn-standard-white"
            shape="round"
            style={{ width: '192px' }}
            onClick={() => inputRef.current.click()}
            loading={isLoading}
          >
            IMPORTAR PLANTILLA
          </Button>
          <CustomDropdown
            overlayClassName="download-template-collection-dropdown"
            typeShowMenu="click"
            placement="right"
            items={[
              {
                label: 'Todos los usuarios',
                action: () => handleDownloadAllDebtorsTemplate()
              },
              {
                label: 'Selección manual',
                action: () => handleOpenCloseModal({ isOpenModal: true })
              }
            ]}>
            <Button
              loading={isLoading}
              className="btn-standard-green"
              shape="round"
              style={{ width: '133px' }}
            >
              DESCARGAR
            </Button>
          </CustomDropdown>
        </div>
      </div>
      <UsersModal
        isModalOpen={isOpenModal}
        handleModalClose={handleOpenCloseModal}
        debtors={debtors}
      />
    </div >
  )
}

export default DownloadTemplateCollection
